import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ConsentCMSService {
    constructor(
        private http: HttpClient
      ) {}

    public getConsentMessages(): Observable<any> {
        const baseApi = '/render/cms';
        let url = baseApi + '/v2/node/planning-consent.json';

        return this.http
        .get(url).pipe(map(response => response)
        , catchError(error => {
        let message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
        return throwError(message);
      }));
    }
}
